import React, { useState, useEffect } from 'react'
import { useParams, useNavigate } from 'react-router-dom';
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import axios from 'axios';
import { toast } from 'react-toastify';
import apiUrl from '../../environment/Api';
import { Link } from "react-router-dom";


const modules = {
    toolbar: [
        [{ header: "1" }, { header: "2" }, { font: [] }],
        [{ size: [] }],
        ["bold", "italic", "underline", "strike", "blockquote"],
        [{ list: "ordered" }, { list: "bullet" }],
        [{ indent: "-1" }, { indent: "+1" }],
        [{ align: [] }],
        [{ color: [] }, { background: [] }],
        ["link", "image", "video"],
        ["clean"],
    ],
};

const formats = [
    "header",
    "font",
    "size",
    "bold",
    "italic",
    "underline",
    "strike",
    "blockquote",
    "list",
    "bullet",
    "indent",
    "link",
    "image",
    "video",
    "color",
    "background",
    "align",
];

function Updatejobportal() {
    const { id } = useParams(); // Get the job posting ID from URL
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(true);
    const [jobData, setJobData] = useState({
        companyname: '',
        designation: '',
        location: '',
        no_of_vacancies: '',
        applied_candidate: '',
        Job_description: '',
        deadline: '',
        start_date: '',
        status: '',
    });

    // Fetch existing job data when component mounts
    useEffect(() => {
        const fetchJobData = async () => {
            try {
                setIsLoading(true);
                const response = await axios.get(`${apiUrl}/jobportal/${id}`);
                // Format dates for form inputs
                const job = response.data;
                if (job.deadline) {
                    job.deadline = job.deadline.split('T')[0]; // Format to YYYY-MM-DD
                }
                if (job.start_date) {
                    job.start_date = job.start_date.split('T')[0]; // Format to YYYY-MM-DD
                }
                setJobData(job);
                setIsLoading(false);
            } catch (error) {
                console.error("Error fetching job data:", error);
                toast.error("Failed to load job data. Please try again.");
                setIsLoading(false);
            }
        };

        if (id) {
            fetchJobData();
        }
    }, [id]);

    // Handle rich text editor changes
    const handleEditorChange = (content) => {
        setJobData({ ...jobData, Job_description: content });
    };

    // Handle form input changes
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setJobData({ ...jobData, [name]: value });
    };

    // Handle form submission
    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            setIsLoading(true);

            // Basic validation
            if (!jobData.companyname || !jobData.designation || !jobData.Job_description) {
                toast.error("Please fill all required fields!");
                setIsLoading(false);
                return;
            }

            // Submit update
            const response = await axios.put(`${apiUrl}/jobportal/${id}`, jobData);
            console.log("Job updated:", response);
            toast.success("Job posting updated successfully!");

            // Redirect back to job listings
            navigate('/jobportal'); // Adjust this path to your job listings page
        } catch (error) {
            console.error("Error updating job:", error.message);
            toast.error("Failed to update job posting. Please try again.");
            setIsLoading(false);
        }
    };

    if (isLoading) {
        return <div className="text-center py-5">Loading job data...</div>;
    }

    return (


        <>
            <div className="" style={{ marginTop: '-80px' }}>
                <div className="row mb-3">
                    <div className="col-lg-11">
                        <Link to="/dashboard" className="text-secondary dashBoard_text">
                            <b>Dashboard / </b>
                        </Link>
                        <Link to="/Jobportal" className="text-secondary dashBoard_text">
                            <b>JobPortal / </b>
                        </Link>
                        <Link to="" className="text-danger dashBoard_text">
                            <b>Updatejobportal</b>
                        </Link>
                        {/* <Link to="" className="text-danger dashBoard_text">
                                            <b>Profile</b>
                                        </Link> */}
                    </div>
                </div>
            </div>
            <h1>Update Job Posting</h1>
            <form onSubmit={handleSubmit}>
                <div className='row mt-3'>
                    <div className='col-lg-6'>
                        <div className="floating-label">
                            <input
                                className="form-control"
                                type="text"
                                name="companyname"
                                placeholder=''
                                value={jobData.companyname}
                                onChange={handleInputChange}
                                required
                            />
                            <label className={jobData.companyname ? "filled" : ""}>
                                Company Name
                            </label>
                        </div>

                        <div className="floating-label">
                            <input
                                className="form-control"
                                type="text"
                                name="designation"
                                placeholder=''
                                value={jobData.designation}
                                onChange={handleInputChange}
                                required
                            />
                            <label className={jobData.designation ? "filled" : ""}>
                                Designation
                            </label>
                        </div>

                        <div className="floating-label">
                            <input
                                className="form-control"
                                type="text"
                                name="location"
                                placeholder=''
                                value={jobData.location}
                                onChange={handleInputChange}
                                required
                            />
                            <label className={jobData.location ? "filled" : ""}>
                                Location
                            </label>
                        </div>

                        <div className="floating-label">
                            <input
                                className="form-control"
                                type="text"
                                name="no_of_vacancies"
                                placeholder=''
                                value={jobData.no_of_vacancies}
                                onChange={handleInputChange}
                                required
                            />
                            <label className={jobData.no_of_vacancies ? "filled" : ""}>
                                Vacancy
                            </label>
                        </div>
                    </div>

                    <div className='col-lg-6'>
                        <div className="floating-label">
                            <input
                                className="form-control"
                                type="text"
                                name="applied_candidate"
                                placeholder=''
                                value={jobData.applied_candidate}
                                onChange={handleInputChange}
                                required
                            />
                            <label className={jobData.applied_candidate ? "filled" : ""}>
                                Applied Candidate
                            </label>
                        </div>

                        <div className="floating-label">
                            <input
                                className="form-control"
                                type="date"
                                name="deadline"
                                placeholder=''
                                value={jobData.deadline}
                                onChange={handleInputChange}
                                required
                            />
                            <label className={jobData.deadline ? "filled" : ""}>
                                Deadline
                            </label>
                        </div>

                        <div className="floating-label">
                            <input
                                className="form-control"
                                type="date"
                                name="start_date"
                                placeholder=''
                                value={jobData.start_date}
                                onChange={handleInputChange}
                                required
                            />
                            <label className={jobData.start_date ? "filled" : ""}>
                                Post Date
                            </label>
                        </div>

                        <div className="floating-label">
                            <select
                                className="form-control"
                                name="status"
                                value={jobData.status || ""}
                                onChange={handleInputChange}
                                required
                            >
                                <option value="">Select status</option>
                                <option value="Active">Active</option>
                                <option value="InActive">InActive</option>
                            </select>
                            <label className={jobData.status ? "filled" : ""}>
                                Select status
                            </label>
                        </div>
                    </div>
                </div>

                <div className="mt-4">
                    <h2>Job Description</h2>
                    <ReactQuill
                        theme="snow"
                        value={jobData.Job_description}
                        onChange={handleEditorChange}
                        modules={modules}
                        formats={formats}
                        placeholder="Write something amazing..."
                    />
                </div>

                <div className="mt-4 d-flex gap-2 mt-5 mb-5">
                    <button type="submit" className="btn btn-danger" disabled={isLoading}>
                        {isLoading ? "Updating..." : "Update"}
                    </button>
                    <button
                        type="button"
                        className="btn btn-secondary"
                        onClick={() => navigate('/jobportal')} // Adjust this path to your job listings page
                    >
                        Cancel
                    </button>
                </div>
            </form>
        </>
    )
}

export default Updatejobportal